import React, { useState } from 'react';
import { motion } from "framer-motion";
import { animationProps } from '../props/props';
import { RowsPhotoAlbum } from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";

import "react-photo-album/rows.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/captions.css";

interface PortfolioProps {
  className?: string;
}

const thumbnailWidth = 145;
const thumbnailHeight = 145;

const photoWidth = 9999;
const photoHeight = 9999;


const thumbnails = [
  { src: require("../images/portfolio/bge/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "BGE", description: "Angular SPA, Sharepoint", alt: "BGE Thumbnail", photos: [
    { src: require("../images/portfolio/bge/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "BGE Screenshot 1" },
    { src: require("../images/portfolio/bge/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "BGE Screenshot 2" },
  ]},
  { src: require("../images/portfolio/hnh/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "DSM HNH", description: "Adobe Experience Manager", alt: "DSM HNH Thumbnail", photos: [
    { src: require("../images/portfolio/hnh/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "DSM Screenshot 1" },
    { src: require("../images/portfolio/hnh/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "DSM Screenshot 2" },
  ]},
  { src: require("../images/portfolio/pa/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Pentair", description: "Adobe Experience Manager", alt: "Pentair Project Thumbnail", photos: [
    { src: require("../images/portfolio/pa/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "PA Screenshot 1" },
    { src: require("../images/portfolio/pa/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "PA Screenshot 2" },
    { src: require("../images/portfolio/pa/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "PA Screenshot 3" },
  ]},
  { src: require("../images/portfolio/ah/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Atlantic Health", description: "Adobe Experience Manager", alt: "Atlantic Health Project Thumbnail", photos: [
    { src: require("../images/portfolio/ah/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "AH Screenshot 1" },
    { src: require("../images/portfolio/ah/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "AH Screenshot 2" },
    { src: require("../images/portfolio/ah/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "AH Screenshot 3" },
  ]},
  { src: require("../images/portfolio/dc/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Dechert Project", description: "Adobe Experience Manager", alt: "Dechert Project Thumbnail", photos: [
    { src: require("../images/portfolio/dc/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "DC Screenshot 1" },
    { src: require("../images/portfolio/dc/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "DC Screenshot 2" },
    { src: require("../images/portfolio/dc/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "DC Screenshot 3" },
    { src: require("../images/portfolio/dc/ss4.jpg"), width: photoWidth, height: photoHeight, alt: "DC Screenshot 4" },
  ]},
  { src: require("../images/portfolio/clc/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "CLC Lodging", description: "Adobe Experience Manager", alt: "CLC Lodging Project Thumbnail", photos: [
    { src: require("../images/portfolio/clc/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "CLC Screenshot 1" },
    { src: require("../images/portfolio/clc/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "CLC Screenshot 2" },
  ]},
  { src: require("../images/portfolio/acs/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "American Cancer Society", description: "Adobe Experience Manager", alt: "American Cancer Society Project Thumbnail", photos: [
    { src: require("../images/portfolio/acs/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "ACS Screenshot 1" },
    { src: require("../images/portfolio/acs/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "ACS Screenshot 2" },
  ]},
  { src: require("../images/portfolio/bc/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Boston College", description: "Adobe Experience Manager", alt: "Boston College Project Thumbnail", photos: [
    { src: require("../images/portfolio/bc/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "BC Screenshot 1" },
    { src: require("../images/portfolio/bc/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "BC Screenshot 2" },
    { src: require("../images/portfolio/bc/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "BC Screenshot 3" },
  ]},
  { src: require("../images/portfolio/bio/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "BIO.org", description: "Drupal", alt: "BIO.org Project Thumbnail", photos: [
    { src: require("../images/portfolio/bio/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "BIO Screenshot 1" },
    { src: require("../images/portfolio/bio/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "BIO Screenshot 2" },
    { src: require("../images/portfolio/bio/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "BIO Screenshot 3" },
  ]},
  { src: require("../images/portfolio/qu/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Quinnipiac Online", description: "DNN", alt: "Quinnipiac Online Project Thumbnail", photos: [
    { src: require("../images/portfolio/qu/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "QU Screenshot 1" },
    { src: require("../images/portfolio/qu/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "QU Screenshot 2" },
  ]},  
  { src: require("../images/portfolio/jb/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Just Born", description: "Drupal", alt: "Just Born Project Thumbnail", photos: [
    { src: require("../images/portfolio/jb/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "JB Screenshot 1" },
    { src: require("../images/portfolio/jb/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "JB Screenshot 2" },
    { src: require("../images/portfolio/jb/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "JB Screenshot 3" },
  ]},
  { src: require("../images/portfolio/kw/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Kelly Way", description: "DNN", alt: "Kelly Way Project Thumbnail", photos: [
    { src: require("../images/portfolio/kw/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "KW Screenshot 1" },
    { src: require("../images/portfolio/kw/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "KW Screenshot 2" },
    { src: require("../images/portfolio/kw/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "KW Screenshot 3" },
  ]},
  { src: require("../images/portfolio/qi/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Quickins", description: "DNN", alt: "Quickins Project Thumbnail", photos: [
    { src: require("../images/portfolio/qi/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "QI Screenshot 1" },
    { src: require("../images/portfolio/qi/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "QI Screenshot 2" },
  ]},
  { src: require("../images/portfolio/nj/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "NJSFDA", description: "DNN", alt: "NJSFDA Project Thumbnail", photos: [
    { src: require("../images/portfolio/nj/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "NJ Screenshot 1" },
    { src: require("../images/portfolio/nj/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "NJ Screenshot 2" },
    { src: require("../images/portfolio/nj/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "NJ Screenshot 3" },
  ]},
  { src: require("../images/portfolio/cw/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Hershey's Chocolate World", description: "Custom/Adobe Experience Manager", alt: "Hershey's Chocolate World Project Thumbnail", photos: [
    { src: require("../images/portfolio/cw/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "CW Screenshot 1" },
    { src: require("../images/portfolio/cw/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "CW Screenshot 2" },
    { src: require("../images/portfolio/cw/ss3.jpg"), width: photoWidth, height: photoHeight, alt: "CW Screenshot 3" },
  ]},
 /*  { src: require("../images/portfolio/cc/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "Cash Course", description: "DNN", alt: "Cash Course Project Thumbnail", photos: [
    { src: require("../images/portfolio/cc/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "CC Screenshot 1" },
    { src: require("../images/portfolio/cc/ss2.jpg"), width: photoWidth, height: photoHeight, alt: "CC Screenshot 2" },
  ]}, */
  { src: require("../images/portfolio/sb/thumb.jpg"), width: thumbnailWidth, height: thumbnailHeight, title: "The Seaboard", description: "Wordpress", alt: "The Seaboard Project Thumbnail", photos: [
    { src: require("../images/portfolio/sb/ss1.jpg"), width: photoWidth, height: photoHeight, alt: "SB Screenshot 1" },
  ]},
];


const Portfolio: React.FC<PortfolioProps> = () => {
  const [index, setIndex] = useState(-1);
  const [currentPhotos, setCurrentPhotos] = useState<any[]>([]);
  const [currentTitle, setCurrentTitle] = useState('');
  const [currentDescription, setCurrentDescription] = useState('');

  const handleThumbnailClick = (thumbnailIndex: number) => {
    const selectedThumbnail = thumbnails[thumbnailIndex];
    setCurrentPhotos(selectedThumbnail.photos);
    setCurrentTitle(selectedThumbnail.title);
    setCurrentDescription(selectedThumbnail.description);
    setIndex(0);
  };

  return (
    <motion.div className="animated-wrapper" {...animationProps}>
      <div className='inner'>
        <div className='row'>
          <div className='col'>
            <p className='mb-md-4 mb-2'>These are some of the various projects I've been a part of. I built the bulk of the CSS/HTML/JS for these projects on a variety of Content Management Systems.</p>
            <RowsPhotoAlbum 
              photos={thumbnails} 
              spacing={(containerWidth) => {
                if (containerWidth < 736) return 10; 
                return 20;                           
              }}
              targetRowHeight= {50}
              rowConstraints={(containerWidth) => {
                if (containerWidth < 508) return { maxPhotos: 4 };
                if (containerWidth < 736) return { maxPhotos: 8 };
                return { maxPhotos: 8 };  
              }}
              onClick={({ index }) => handleThumbnailClick(index)}/>
            <Lightbox
              slides={currentPhotos}
              open={index >= 0}
              index={index}
              close={() => setIndex(-1)}
              carousel={{ finite: true }}
              // enable optional lightbox plugins
              plugins={[Zoom, Counter]}
              toolbar={{
                buttons: [
                  <div key="album-title" className="yarl__albumtitle">
                    <h3>{currentTitle}</h3>
                    <p>{currentDescription}</p>
                  </div>,
                  "zoom",
                  "close"
                ]
              }}
            />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Portfolio;
